module.exports = __webpack_public_path__ + "img/american-ex.fdb5d8f4.png";